export const firstLetterToUpper = (text: string) => {
  return text.charAt(0).toUpperCase() + text.slice(1); //or if you want lowercase the rest txt.slice(1).toLowerCase();
};

export const firstLetterToLower = (text: string) => {
  return text.charAt(0).toLowerCase() + text.slice(1);
};

export const NairaSymbol = '₦';
